<div #wrapper class="pr-form-wrapper">
  <div class="pr-form-backdrop" (click)="close()"></div>
  <div class="pr-form-container">
    <ng-template veaFormHost></ng-template>
    @if (load) {
      <div class="pr-form-loading">
        <pr-icon name="autorenew"></pr-icon>
      </div>
    }
  </div>
</div>
